import { useEffect, useState } from "react";
import { Flex, useBreakpointValue } from "@chakra-ui/react";

import { ClienteDTO } from "../../../dtos/ClienteDTO";
import DTPaginate from "./DTPaginate";
import DTTable from "./DTTable";
import DTSearch from "./DTSearch";
import DTCards from "./DTCards";

interface DTClienteParams {
	data: ClienteDTO[];
	setModalAddEditClienteVisible: (param: boolean) => void;
	setIdClienteModal: (param: string) => void;
}

const DTClientes: React.FC<DTClienteParams> =({ 
	data,
	setModalAddEditClienteVisible,
	setIdClienteModal
}) => {
	const isWideVersion = useBreakpointValue({
		base: false,
		lg: true,
	});

	const [loading, setLoading] = useState(true);

	const [pesqClientes, setPesqClientes] = useState<ClienteDTO[]>(data);
	const [clientes, setClientes] = useState<ClienteDTO[]>(data);

	const [sort, setSort] = useState({ por: '', cres: true });
	const [controls, setControls] = useState({
		page: 1,
		perPage: 10,
		totalPage: Math.ceil(data.length / 10),
	});

	useEffect(() => {
		setClientes(data.slice(0, 10));
		setLoading(false);
	}, []);

	async function handleUpdateList(
		page: number,
		perPage: number,
		lancamentoss: ClienteDTO[],
	) {
		const auxPage = page - 1;
		const start = auxPage * perPage;
		const end = start + perPage;

		setClientes(lancamentoss.slice(start, end));
	}

	return (
		<Flex w="100%" flexDir="column">
			<DTSearch
				clientes={data}
				setPesqClientes={setPesqClientes}
				controls={controls}
				setControls={setControls}
				handleUpdateList={handleUpdateList}
			/>

			{isWideVersion && (
				<DTTable
					clientes={clientes}
					pesqClientes={pesqClientes}
					sort={sort}
					setSort={setSort}
					controls={controls}
					handleUpdateList={handleUpdateList}
					setModalAddEditClienteVisible={setModalAddEditClienteVisible}
					setIdClienteModal={setIdClienteModal}
				/>
			)}

			{!isWideVersion && !loading && (
				<DTCards
					clientes={clientes}
					setModalAddEditClienteVisible={setModalAddEditClienteVisible}
					setIdClienteModal={setIdClienteModal}
				/>
			)}

			<DTPaginate
				pesq_length={pesqClientes.length}
				pesqClientes={pesqClientes}
				controls={controls}
				setControls={setControls}
				handleUpdateList={handleUpdateList}
			/>
		</Flex>
	);
};

export default DTClientes;